module.exports = __webpack_public_path__ + "static/media/despacho.765319c3.svg";